import "@babel/polyfill";
import Vue from 'vue';
import "jquery";
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import AppHeader from './components/Header.vue';
import App from './App.vue';
import AppMain from './components/Main.vue';
import AppFooter from './components/Footer.vue';

Vue.component('AppHeader', AppHeader);
Vue.component('AppMain', AppMain);
Vue.component('AppFooter', AppFooter);

var vm = new Vue({
  el: '#app',
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js